import { createAction, props } from '@ngrx/store';
import { LookBook } from '@epicuro-next/models/engagement';

export const createLookBook = createAction(
  '[ShopTheLook] Create lookBook',
  props<{ lookBook: LookBook }>(),
);

export const createLookBookNotify = createAction(
  '[ShopTheLook] Create LookBook Notify',
  props<{ message: string }>(),
);

export const createLookBookSuccess = createAction(
  '[ShopTheLook] Create LookBook Success',
  props<{ lookBook: LookBook }>(),
);

export const createLookBookError = createAction(
  '[ShopTheLook] Create LookBook Error',
  props<{ error: string }>(),
);
